(function (angular) {
	'use strict';

	angular
		.module('iraModule')
		.controller('IraSignupMobileVerifyForm', [
			'$rootScope',
			'globalConfig',
			'urlFactory',
			IraSignupMobileVerifyFunction
		]);

	function IraSignupMobileVerifyFunction($rootScope, globalConfig, urlFactory) {
		var iraSignupMobileVerify = this;

		iraSignupMobileVerify.clearNewPhone = function() {
			if(iraSignupMobileVerify.phoneNumberId !== '-1'){
				iraSignupMobileVerify.newPhoneNumber = '';
			}
		};
	
		iraSignupMobileVerify.displayErrors = function() {
			var valueArr;
			Object.keys(iraSignupMobileVerify.serverSideErrorMap).forEach(function(key) {
				valueArr = iraSignupMobileVerify.serverSideErrorMap[key];
				angular.forEach(valueArr, function(value) {
					$rootScope.ToastFactory.show({
						message: value,
						type: 'error'
					});
				});
			});
		};
		
		iraSignupMobileVerify.$onInit = function() {
			angular.extend(iraSignupMobileVerify, globalConfig);
			
			if(angular.isDefined(iraSignupMobileVerify.serverSideErrorMap)) {
				iraSignupMobileVerify.displayErrors();
			}
		};
	}
})(window.angular);